import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Loader2 } from "lucide-react";
import { stageLabel } from "../../lib/stageLabels";

const STAGES = ["New","Researching","Qualified","Contacted","Replied","Assessment Requested","Assessment Delivered","Paid","Repeat Customer","Lost Opportunity"];

export default function CRM() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/prospects").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (items === null) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 text-sky-400 animate-spin" /></div>;

  const grouped = STAGES.reduce((acc, s) => ({ ...acc, [s]: items.filter((p) => p.stage === s) }), {});

  return (
    <div data-testid="crm-board">
      <div className="tick-label text-sky-400 mb-2">/ CRM Pipeline</div>
      <h1 className="font-display font-black text-3xl text-slate-100 mb-6">Kanban Board</h1>

      <div className="flex gap-px bg-[var(--border-soft)] overflow-x-auto">
        {STAGES.map((s) => (
          <div key={s} className="bg-[var(--bg-secondary)] min-w-[240px] flex-shrink-0 p-3">
            <div className="flex items-center justify-between mb-3">
              <div className="font-mono text-[10px] tracking-widest uppercase text-sky-400">{stageLabel(s)}</div>
              <div className="font-mono text-[10px] text-slate-500">{grouped[s].length}</div>
            </div>
            <div className="space-y-2">
              {grouped[s].map((p) => (
                <Link key={p.prospect_id} to={`/internal/prospects/${p.prospect_id}`} className="block panel p-3 hover:border-sky-500/60" data-testid={`crm-card-${p.prospect_id}`}>
                  <div className="text-sm text-slate-100 mb-1 line-clamp-2">{p.company_name}</div>
                  <div className="flex items-center justify-between font-mono text-[10px]">
                    <span className="text-slate-500">{p.primary_naics || "—"}</span>
                    {p.score != null && <span className="text-sky-400">{p.score}/100</span>}
                  </div>
                </Link>
              ))}
              {grouped[s].length === 0 && <div className="text-xs text-slate-600 italic py-2 text-center">empty</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
